export default __webpack_public_path__ + "static/media/logo2.16f35a99.png";